import React from 'react';
import styles from './index.module.scss';

const index = () => {
	return (
		<div className={styles.container}>
			<h2>Page not found!</h2>
		</div>
	);
};

export default index;
